import moment from 'moment-jalaali';
import { convertDigitToProperFormat } from '../../../utils/number';

export default {
  code: 'کد',
  enter: 'ورود',
  login: 'ورود',
  email: 'ایمیل',
  emailOrPhone: 'نام کاربری',
  submit: 'ارسال',
  goBack: 'بازگشت',
  getCode: 'دریافت کد',
  homeUrl: 'https://rastech.ir',
  enterToLogin: 'وارد شوید',
  hasRegister: 'قبلاً در سامانه ثبت‌نام کرده‌اید؟',
  newUser: 'کاربر جدید هستید؟',
  register: 'ثبت نام',
  password: 'رمز عبور',
  password2: 'تکرار رمز عبور',
  phoneNumber: 'مثال:۰۹۱۲۳۴۵۶۷۸۹',
  loginWithEmail: 'ورود با کلمه عبور',
  loginWithPhone: 'ورود با کد یک بار مصرف',
  setName: 'نام خود را وارد کنید',
  rememberMe: 'مرا به خاطر بسپار',
  phoneNumberNotMatch: 'شماره تلفن وارد شده نامعتبر است',
  copyright: 'رستک © ۱۴۰۱ ',
  rastechSite: 'https://rastech.ir',
  enterYourName: 'لطفا نام و نام خانوادگی خود را وارد کنید',
  name: 'نام و نام خانوادگی',
  AccessDenied: 'برای دسترسی به این صفحه لطفا به حساب خود وارد شوید',
  happyYalda: 'یلدا مبارک',
  happyNewYear: 'سال نو مبارک',
  newYearNote:
    'به امید سالی سرشار از مهر در کنار شما\n' +
    'برای نجات جان انسان‌ها\n' +
    'سلامت قلب‌ها\n' +
    'و رقم زدن معجزه‌ها\n' +
    `بهار ${convertDigitToProperFormat(moment(new Date().valueOf() + 20 * 24 * 60 * 60 * 1000).format('jYYYY'))} مبارک!\n`,
  service: 'لطفا با حساب نماینده بیمارستان وارد شوید',
  requireServiceAccount:
    'برای ادامه لازم است به حساب نماینده بیمارستان وارد شوید. آیا ادامه می‌دهید؟',
  happyRamazan: 'رمضان مبارک',
  anniversaryBoldTitle: 'ششمین سالگرد',
  anniversaryTitle: 'رویش شرکت رستک',
  anniversaryText:
    '6 سال از آغاز راه رستک گذشت. از همراهی و اعتماد بی‌دریغ شما در این مسیر سپاسگزاریم...',
  switchUser: 'تغییر کاربر',
  loginAgain: 'لطفا دوباره وارد شوید',

  getLoginPageTitle(title: string) {
    return `${title}`;
  },
  alreadyLoggedInWith(name: string) {
    return `شما با حساب «${name}» وارد شده اید ایا می‌خواهید با همین حساب ادامه بدهید؟`;
  },
  accessDeniedWith(name: string) {
    return `شما با کاربر «${name}» به این صفحه دسترسی ندارید لطفا با کاربری دیگری وارد شوید.`;
  },
};
